import React, { useEffect, useMemo, useState } from 'react';
import ConfigModal from '../ConfigModal';
import { DatePicker, Input } from 'antd';
import PropTypes from 'prop-types';
import { getAddOnTypes, getConfig } from '../../utils/api';
import AddOnSelect from '../AddOnSelect';
import DatabaseSelect from '../DatabaseSelect';
import moment from 'moment';

const OrganizationModal = ({ open, mode, organization, onCancel, onSubmit }) => {
	const [availableDatabases, setAvailableDatabases] = useState([]);
	const [availableAddOns, setAvailableAddOns] = useState([]);

	const isCreate = mode === 'create';

	const values = useMemo(() => {
		if (isCreate) {
			return {};
		}

		let addOnTypes = [];
		if (organization.addOns) {
			addOnTypes = organization.addOns.map((addOn) => addOn.type);
		}

		return {
			name: organization.name,
			address: organization.address,
			zipCode: organization.zipCode,
			phone: organization.phone,
			city: organization.city || '',
			licenseKey: organization.licenseKey || '',
			expiryDate: moment(organization.expiryDate) || null,
			addOns: addOnTypes,
			databases: (organization.databases && Array.from(organization.databases.toUpperCase())) || [],
		};
	}, [isCreate, organization]);

	useEffect(() => {
		const fetchData = async () => {
			try {
				if (!availableDatabases.length) {
					const config = await getConfig();
					if (config && config.databases) {
						setAvailableDatabases(
							config.databases.filter((db) => !['c', 'y'].includes(db.key.toLowerCase()))
						);
					}
				}

				if (!availableAddOns.length) {
					const addOnTypes = await getAddOnTypes();

					setAvailableAddOns(addOnTypes);
				}
			} catch (error) {
				console.error('Failed to fetch databases & addOns', error);
			}
		};
		fetchData();
	}, []);

	return (
		<ConfigModal
			title={`${isCreate ? 'Skapa' : 'Redigera'} kund`}
			open={open}
			onSubmit={onSubmit}
			onCancel={onCancel}
			values={values}
			createNew={isCreate}
			disableMask
			formItems={[
				{
					id: 'name',
					label: 'Namn',
					decorator: {
						rules: [{ required: true, message: 'Namn är obligatorisk' }],
					},
					component: <Input autoComplete='organization' autoFocus />,
				},
				{
					id: 'address',
					label: 'Adress',
					decorator: {},
					component: <Input autoComplete='address-line1' />,
				},
				{
					id: 'city',
					label: 'Stad',
					decorator: {},
					component: <Input autoComplete='locality' />,
				},
				{
					id: 'zipCode',
					label: 'Postnummer',
					decorator: {},
					component: <Input autoComplete='postal-code' />,
				},
				{
					id: 'phone',
					label: 'Telefonnummer',
					decorator: {},
					component: <Input type='tel' autoComplete='tel' />,
				},
				{
					id: 'licenseKey',
					label: 'Licensnyckel',
					decorator: { rules: [{ required: true, message: 'Licensnyckel är obligatorisk' }] },
					component: <Input />,
				},
				{
					id: 'databases',
					label: 'Databaser',
					decorator: { rules: [{ required: true, message: 'Databaser är obligatorisk' }] },
					component: <DatabaseSelect availableDatabases={availableDatabases} />,
				},
				{
					id: 'expiryDate',
					label: 'Utgångsdatum',
					decorator: { rules: [{ required: true, message: 'Utgångsdatum är obligatorisk' }] },
					component: <DatePicker format={'YYYY-MM-DD'} placeholder='Välj datum' />,
				},
				{
					id: 'addOns',
					label: 'Plustjänster',
					decorator: {},
					component: <AddOnSelect availableAddOns={availableAddOns} />,
				},
			]}
		/>
	);
};

OrganizationModal.propTypes = {
	mode: PropTypes.oneOf(['create', 'edit']).isRequired,
	organization: PropTypes.object.isRequired,
	open: PropTypes.bool,
	onSubmit: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
};

OrganizationModal.defaultProps = {
	open: false,
};

export default OrganizationModal;



// WEBPACK FOOTER //
// ./src/components/organization/organizationModal.jsx